import { Box, Card } from '@zillow/constellation-10';

import { LoadingButton, LoadingParagraph, LoadingTag } from '@zg-rentals/loading-components';
import { statusMap, statusTagToneMap } from '@zg-rentals/property-condition-utils';
import { PropertyConditionPhase } from '@zg-rentals/rental-manager-env';

import { singleTextLineStyles } from '../../../../styles';

import ConnectedModuleCard from '../../../ConnectedModuleCard';

import type { TagPropsInterface } from '@zillow/constellation-10';
import type { UserPropertySummaryPropertyConditionsReportWebDto } from '@zg-rentals/ts-rental-manager-api-beta-client';

type Props = {
  title: string;
  description: string;
  actionUrl: string;
  actionText: string;
  propertyConditionReport?: UserPropertySummaryPropertyConditionsReportWebDto;
  listingAlias: string;
};

const PropertyConditionModule = ({ propertyConditionReport, title, actionUrl, actionText }: Props) => {
  /**
   * Sets the border state for less than or equal to SM
   *
   * this component hides the border when the component is not empty
   * this component is rendered only when there is a lease
   * always hide border
   */
  const hideBorder = true;

  const isLoading = propertyConditionReport == null;
  const { name = '', phase = '', status = '' } = propertyConditionReport || {};

  return (
    <ConnectedModuleCard
      data-testid="PropertyConditionModule"
      className="PropertyConditionModule"
      title={title}
      hideBorderOnMobile={hideBorder}
    >
      <Card tone="neutral" elevated={false}>
        <Box css={{ display: 'flex', gap: '200', flexDirection: 'column' }}>
          <LoadingParagraph
            textStyle="body-sm-bold"
            isLoading={isLoading}
            loadingWidth="90%"
            css={{
              fontSize: { lg: 'body' },
              ...singleTextLineStyles,
            }}
            className="fs-mask"
          >
            {name}
          </LoadingParagraph>
          <Box css={{ display: 'flex', gap: '200', flexWrap: 'wrap' }}>
            <LoadingTag
              size="sm"
              tone={statusTagToneMap[status as keyof typeof statusTagToneMap] as TagPropsInterface['tone']}
              isLoading={isLoading}
              loadingWidth="20%"
            >
              {statusMap[status as keyof typeof statusMap]}
            </LoadingTag>
            <LoadingTag size="sm" tone="info" isLoading={isLoading} loadingWidth="20%">
              {phase === PropertyConditionPhase.MOVE_OUT ? 'Move out' : 'Move in'}
            </LoadingTag>
          </Box>
          {Boolean(actionText || isLoading) && (
            <LoadingButton
              tone="brand"
              emphasis="filled"
              css={{ marginTop: '200' }}
              asChild={true}
              isLoading={isLoading}
              loadingWidth="50%"
            >
              <a href={actionUrl}>{actionText}</a>
            </LoadingButton>
          )}
        </Box>
      </Card>
    </ConnectedModuleCard>
  );
};

export default PropertyConditionModule;
